import React, { useEffect, useRef } from 'react';

// taken from
// https://overreacted.io/making-setinterval-declarative-with-react-hooks

export function useInterval(callback, delay) {
  const savedCallback = useRef(undefined);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      // @ts-ignore
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
